export default __webpack_public_path__ + "static/media/icon-coin-grt.4a6a45d3.svg";